module.exports = __webpack_public_path__ + "3573c125ccff32e41e30520ef3a0ffe5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-0.png
// module id = 2991
// module chunks = 0